export default __webpack_public_path__ + "static/media/KOD0095-min.52c636cf.webp";